export class SvgmapLegendItem {
  name: string;
  color: string;
}
